// import React, { Component } from 'react'
// import 'bootstrap/dist/css/bootstrap.css';
// import axios from 'axios';
// import CustomHeader from '../components/Header'
// import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
// import Select from 'react-select'
// import GroupVRNSelect from '../containers/comps/GroupVRNSelectContainer'
// import AdvanceTableWithDeleteButton from '../components/Tables/AdvanceTableWithDeleteButton';
// import Swal from 'sweetalert2/dist/sweetalert2.js';
// import axiosConfig from "../config/axiosConfig";

// import CheckboxlistControl from '../components/CheckboxList/CheckboxlistControl'
// import { Marker } from 'google-maps-react';

// import '../css/customcheckbox.css'

// const customStyles = {
//   option: (provided, state) => ({
//     ...provided,
//     color: state.isSelected ? 'black' : 'black',
//     backgroundColor: state.isSelected ? '#7367f0' : 'white'
//   }),
//   control: (provided) => ({
//     ...provided,
//     borderRadius: '50px',
//     borderColor: '#7367f0'

//   })
// }

// const firstDate = new Date();
// const currentDate = new Date();

// class Feedback extends React.Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       telematicsFeature: [
//         { id: 1, value: " Suspicious Transaction Alerts", isChecked: false },
//         { id: 2, value: " Vehicle Maintenance Reminders & Log", isChecked: false },
//         { id: 3, value: " Safety Score", isChecked: false },
//         { id: 4, value: " Bar Graphs & Tables", isChecked: false },
//         { id: 5, value: " General & Trend Reports", isChecked: false }
//       ],

//       IsHelpfulNo: '',
//       IsHelpfulYes: '',
//       IsHelpful: false,

//       IsEasyToUseNo: '',
//       IsEasyToUseYes: '',
//       IsEasyToUse: false,

//       SelectedFeature: [],
//       FeedbackComments: '',




//     }

//     this.OnChangeHelpfull = this.OnChangeHelpfull.bind(this);
//     this.saveFeedback = this.saveFeedback.bind(this);
//     this.OnChangeEasyToUse = this.OnChangeEasyToUse.bind(this);
//     this.OnchangeHandler = this.OnchangeHandler.bind(this);
//   }


//   handleCheckChildElement = (event) => {

//     let telematicsFeature = this.state.telematicsFeature
//     telematicsFeature.forEach(feature => {
//       if (feature.value === event.target.value)
//         feature.isChecked = event.target.checked
//     })

//     let dt = []
//     telematicsFeature.forEach(feature => {
//       if (feature.isChecked === true) {
//         let card = {
//           DescId: feature.id,
//           Description: feature.value
//         }
//         dt.push(card);
//       }
//     })

//     this.setState({ SelectedFeature: dt })
//     console.log("Selected Features:", dt)

//     this.setState({ telematicsFeature: telematicsFeature })
//   }


//   async OnChangeHelpfull(e) {


//     if (e.target.value == "IsHelpfulYes" & e.target.checked) {
//       await this.setState({ IsHelpfulNo: '' });
//       await this.setState({ IsHelpfulYes: 'Yes' });
//       await this.setState({ IsHelpful: true });
//     }
//     else if (e.target.value == "IsHelpfulNo" & e.target.checked) {

//       await this.setState({ IsHelpfulNo: 'No' });
//       await this.setState({ IsHelpfulYes: '' });
//       await this.setState({ IsHelpful: false });
//     }


//     console.log("Is Helpful", this.state.IsHelpful);
//     //this.setState({ openModel: false });

//   }

//   async OnChangeEasyToUse(e) {


//     if (e.target.value == "IsEasyToUseYes" & e.target.checked) {
//       await this.setState({ IsEasyToUseNo: '' });
//       await this.setState({ IsEasyToUseYes: 'Yes' });
//       await this.setState({ IsEasyToUse: true });
//     }
//     else if (e.target.value == "IsEasyToUseNo" & e.target.checked) {

//       await this.setState({ IsEasyToUseNo: 'No' });
//       await this.setState({ IsEasyToUseYes: '' });
//       await this.setState({ IsEasyToUse: false });
//     }


//     console.log("Is  EasyToUse", this.state.IsEasyToUse);
//     //this.setState({ openModel: false });

//   }

//   saveFeedback(e) {
//     var self = this;
//     e.preventDefault()
//     const data = {
//       AccountBranchId: this.props.data.selectedBranchId,
//       // UserId: this.state.fpEmail,
//       IsHelpful: this.state.IsHelpful,
//       IsEasyToUse: this.state.IsEasyToUse,
//       FeedbackComments: this.state.FeedbackComments,
//       UsefulFeaturelist: this.state.SelectedFeature
//     }


//     let token = localStorage.getItem('token');
//     axiosConfig.defaults.headers.common['Token'] = token;
//     axiosConfig.post('Portal/UserFeedback', data)
//       .then(res => {
//         Swal.fire({
//           icon: 'success',
//           title: 'Successfully Submitted',
//           text: 'Thank you.',
//         })
//       }
//       )
//       .catch(function (error) {
//         self.setState({ fpModel: false });
//         Swal.fire({
//           icon: 'error',
//           confirmButtonText: 'Okay'
//         })
//       }
//       );
//   }

//   OnchangeHandler(p) {
//     var newState = {};
//     newState[p.target.name] = p.target.value;
//     this.setState(newState);
//   }



//   render() {

//     const { FeedbackComments } = this.state;
//     return (
//       <div>
//         <CustomHeader></CustomHeader>
//         <Row className="p-3">
//           <Card className="p-3" style={{ width: "100%" }}>
//             <Card.Title>
//               <div className="pull-left">
//                 Feedback
//                 <br></br>
//               </div>
//             </Card.Title>

//             <Card.Body>
              
//               <Row>
              
//                 <div className="col-md-12 col-12" style={{ textAlign: 'left' }}>
//                   1) Has the Shell Telematics Portal been helpful in helping you manage your fleet more effectively?
//                 </div>
//               </Row>
//               <Row>
//                 <div className="col-md-12 col-12" style={{ textAlign: 'left' }}>
//                   <ul style={{ paddingLeft: '0px' }}>
//                     <li className="d-inline-block mr-2">
//                       <div className="vs-radio-con vs-radio-warning">
//                         <input type="radio" name="vueradisize" id="IsHelpfulYes" defaultValue="false" value="IsHelpfulYes" onChange={this.OnChangeHelpfull} />
//                         <span className="vs-radio">
//                           <span className="vs-radio--border" />
//                           <span className="vs-radio--circle" />
//                         </span>
//                         <span>Helpful</span>
//                       </div>
//                     </li>
//                     <li className="d-inline-block mr-2">
//                       <div className="vs-radio-con vs-radio-warning">
//                         <input type="radio" name="vueradisize" defaultValue="false" id="IsHelpfulNo" value="IsHelpfulNo" onChange={this.OnChangeHelpfull} />
//                         <span className="vs-radio">
//                           <span className="vs-radio--border" />
//                           <span className="vs-radio--circle" />
//                         </span>
//                         <span>Not Helpful</span>
//                       </div>
//                     </li>
//                   </ul>
//                 </div>

//               </Row>
//               <Row>

//                 <div className="col-md-12 col-12" style={{ textAlign: 'left' }}>
//                   2) Is the Shell Telematics Portal ease to use??
//                 </div>

//               </Row>
//               <Row>
//                 <div className="col-md-12 col-12" style={{ textAlign: 'left' }}>

//                   <ul style={{ paddingLeft: '0px' }}>
//                     <li className="d-inline-block mr-2">
//                       <div className="vs-radio-con vs-radio-warning">
//                         <input type="radio" name="easy" id="IsEasyToUseYes" defaultValue="false" value="IsEasyToUseYes" onChange={this.OnChangeEasyToUse} />
//                         <span className="vs-radio">
//                           <span className="vs-radio--border" />
//                           <span className="vs-radio--circle" />
//                         </span>
//                         <span>Very easy</span>
//                       </div>
//                     </li>
//                     <li className="d-inline-block mr-2">
//                       <div className="vs-radio-con vs-radio-warning">
//                         <input type="radio" name="easy" defaultValue="false" id="IsEasyToUseNo" value="IsEasyToUseNo" onChange={this.OnChangeEasyToUse} />
//                         <span className="vs-radio">
//                           <span className="vs-radio--border" />
//                           <span className="vs-radio--circle" />
//                         </span>
//                         <span>Not easy at all</span>
//                       </div>
//                     </li>
//                   </ul>

//                 </div>

//               </Row>
//               <Row>

//                 <div className="col-md-12 col-12" style={{ textAlign: 'left' }}>
//                   3) Which feature or section of the Shell Telematics Portal do you find most useful? (you can tick more than one option)
//                 </div>

//               </Row>

//               <Row>
//                 <div className="col-md-12 col-12" style={{ textAlign: 'left' }}>
//                   <ul className="d-inline-block" style={{ listStyleType: 'none', paddingLeft: '0px' }}>
//                     {
//                       this.state.telematicsFeature.map((feature) => {
//                         return (<CheckboxlistControl handleCheckChildElement={this.handleCheckChildElement}  {...feature} />)
//                       })
//                     }
//                   </ul>
//                 </div>

//               </Row>
//               <Row>

//                 <div className="col-md-12 col-12" style={{ textAlign: 'left' }}>
//                   4) What improvements would you like to suggest to the Shell Telematics Portal?
//                 </div>
//               </Row>
//               <Row>
//                 <div className="col-md-12 col-12" style={{ textAlign: 'left' }}>
//                   <textarea
//                     className="form-control"
//                     value={this.state.FeedbackComments}
//                     name="FeedbackComments"
//                     onChange={this.OnchangeHandler}
//                     required
//                   />
//                 </div>




//               </Row>
//               <Row>
                
//               </Row>

//               <Row>
//                 <div className="col-md-12 col-12" style={{ textAlign: 'center', marginTop: '8px' }}>
//                   <button type="submit" className="btn btn-shell mr-1 mb-1" onClick={this.saveFeedback} >Save</button>
//                 </div>
//               </Row>
//             </Card.Body>
//           </Card>
//         </Row>
        
//       </div>


//     );
//   }
// }

// export default Feedback;

import React, { useState } from 'react';
import '../css/FeedBack.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from "../config/axiosConfig";
import {connect} from 'react-redux'
import {selectBranch} from '../services/actions/action'

const MAX_RATING = 10;

function Feedback(props) {
  const [rating, setRating] = useState(0);
  const [rating2, setRating2] = useState(0);
  const [feedback, setFeedback] = useState('');

  const handleRatingChange = (value) => {
    setRating(value);
  };

  const handleRatingChange2 = (value) => {
    setRating2(value);
  };

  const handleFeedbackChange = (event) => {
    debugger
    setFeedback(event.target.value);
    
    
    
  };

  const handleSubmit = () => {

    debugger
   
    //e.preventDefault()
    const data = {
      AccountBranchId: props.data.selectedBranchId,
      // UserId: this.state.fpEmail,
      IsHelpful: rating,
      IsEasyToUse: rating2,
      FeedbackComments: feedback,
      UsefulFeaturelist: null
    }


    let token = localStorage.getItem('token');
    axiosConfig.defaults.headers.common['Token'] = token;
    axiosConfig.post('Portal/UserFeedback', data)
      .then(res => {
        Swal.fire({
          icon: 'success',
          title: 'Successfully Submitted',
          text: 'Thank you.',
        })
      }
      )
      .catch(function (error) {
        //self.setState({ fpModel: false });
        
        Swal.fire({
          icon: 'error',
          confirmButtonText: 'Okay'
        })
      }
      );
    // Swal.fire({
    //   icon: 'success',
    //   title: 'Successfully Submitted',
    //   text: 'Thank you.',
    // });
    // You can add the logic to submit the feedback to your server/database here
    console.log(`Rating: ${rating}, Feedback: ${feedback}`);
    // Reset the state after submitting if needed
    setRating(0);
    setRating2(0);
    setFeedback('');
    
  };


  
  return (
    <div className="App" >
      
      <div>
        How would you rate your satisfaction with the Shell Telematics experience?<br/><br/>
        <div className="rating-buttons">
          {Array.from({ length: MAX_RATING }, (_, index) => (
            <button
              key={index + 1}
              className={`rating-button ${index + 1 <= rating ? 'selected' : ''}`}
              onClick={() => handleRatingChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
        <div>Not Satisfied &emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp;&emsp;&emsp; &emsp; Very Satisfied</div>
        <br/><br/>
      </div>
      <div>
        How can we make your Shell Telematics experience even better?<br/><br/>
        <textarea
          rows="4"
          cols="85"
          value={feedback}
          onChange={handleFeedbackChange}
          placeholder="Write your feedback here..."
        />
      </div>
      <br/><br/>
      <div>
        How easy was it to use Shell Telematics?<br/><br/>
        <div className="rating-buttons">
          {Array.from({ length: MAX_RATING }, (_, index) => (
            <button
              key={index + 1}
              className={`rating-button ${index + 1 <= rating2 ? 'selected' : ''}`}
              onClick={() => handleRatingChange2(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
        <div>Very Hard&emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp;&emsp; &emsp;&emsp;&emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp;&emsp;&emsp; &emsp; Very Easy</div>
        <br/><br/>
      </div>
      {/* <button onClick={handleSubmit} style={{color:"white",backgroundColor:"orange"}}>Save</button> */}
                <div  style={{ textAlign: 'center', marginTop: '8px' }}>
                  <button type="submit" className="btn btn-shell mr-1 mb-1" onClick={handleSubmit} >Save</button>
                </div>
    </div>
  );
}


const mapStateToProps = state => ({
  data:state.userItems
})

const mapDispatchToProps = dispatch => ({
  selectBranchHandler:data=>dispatch(selectBranch(data))
})

export default connect(mapStateToProps,mapDispatchToProps)(Feedback)
// export default Feedback;

